import { useSelector } from "react-redux";
import Sidebar from "../../Component/SideBar/SideBar";

export default function DashboardLayout({ children }) {
  const { role } = useSelector((state) => state.auth);
  const stored = JSON.parse(localStorage.getItem("auth") || "{}");
  const userRole = role || stored.role || "admin";

  console.log("Layout Role:", userRole);

  return (
    <div className="layout">
      <Sidebar role={userRole} />
      <div className="content">{children}</div>
    </div>
  );
}
